import { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useTranslation } from "react-i18next";
import { useConsultantRequestHardCopy } from "../hooks/useGetDataQuery";
import { useToastContext } from "../Lib/Contexts/toastContext";

const HardCopyRequest = ({ hardCopyDialogVisible, setHardCopyDialogVisible }: any) => {
  const { t } = useTranslation();
  const { showToast } = useToastContext();
  const [address, setAddress] = useState("");

  const { mutate: requestHardCopy, isPending: isPendingRequestHardCopy } = useConsultantRequestHardCopy();

  const onHide = () => {
    if (isPendingRequestHardCopy) return;
    setAddress("");
    setHardCopyDialogVisible(false);
  };

  const showRequestError = (code?: string) => {
    const detail = code === "C205" ? t("hardCopyRequestAlreadyPending") : t("hardCopyRequestFailed");
    showToast({ severity: "error", summary: t("error"), detail });
  };

  const onConfirm = () => {
    requestHardCopy(address.trim(), {
      onSuccess: (data) => {
        if (data?.success === false) {
          showRequestError(data?.code);
          return;
        }
        showToast({ severity: "success", summary: t("success"), detail: t("hardCopyRequestSuccess") });
        setAddress("");
        setHardCopyDialogVisible(false);
      },
      onError: (error: any) => {
        showRequestError(error?.response?.data?.code);
      }
    });
  };

  const footerContent = (
    <div className="flex justify-content-end gap-2">
      <Button
        style={{
          backgroundColor: "white",
          width: "10rem",
          height: "3rem",
          borderRadius: "10px",
          border: "1.5px solid #2D3967",
          color: "#2D3967",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem"
        }}
        disabled={isPendingRequestHardCopy}
        onClick={onHide}
      >
        <img src="/cancel.svg" />
        <p className="m-0 font-bold">{t("discard")}</p>
      </Button>
      <Button
        style={{
          backgroundColor: "rgba(99, 131, 244, 1)",
          width: "10rem",
          height: "3rem",
          borderRadius: "10px",
          color: "white",
          border: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem"
        }}
        disabled={address.trim() === "" || isPendingRequestHardCopy}
        loading={isPendingRequestHardCopy}
        onClick={onConfirm}
      >
        {!isPendingRequestHardCopy && <img src="/Check.svg" />}
        <p className="m-0 font-bold">{t("confirm")}</p>
      </Button>
    </div>
  );

  return (
    <Dialog
      header={t("hardCopy")}
      footer={footerContent}
      visible={hardCopyDialogVisible}
      draggable={false}
      style={{ width: "35vw", borderRadius: "24px", overflow: "hidden" }}
      onHide={onHide}
      blockScroll
    >
      <div className="flex flex-column gap-4">
        <div className="flex flex-column align-items-center gap-2 text-center">
          <img src="/passwordResetSuccessIcon.png" alt="Hard Copy Ready" style={{ width: "10rem" }} />
          <p className="m-0 text-2xl font-bold" style={{ color: "#2D3967" }}>{t("hardCopyReady")}</p>
          <p className="m-0" style={{ color: "#727A99" }}>{t("hardCopyReadyDescription")}</p>
        </div>
        <div className="flex flex-column gap-1">
          <label htmlFor="hardCopyAddress" style={{ color: "#727A99" }}>
            {t("yourAddress")} <span style={{ color: "#E3506B" }}>*</span>
          </label>
          <InputTextarea
            id="hardCopyAddress"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder={t("enterYourAddress")}
            rows={4}
            style={{ resize: "none" }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default HardCopyRequest;
